import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Eye } from "lucide-react";
// import { ScrollArea } from "@/components/ui/scroll-area";
import { useEffect, useState } from "react";
import { apiResponseType } from "@/Api";
import { cn } from "@/lib/utils";

export type TypeParams = {
  funcParams?: string | object;
  func: (params: any) => apiResponseType;
};
type Labels = {
  title: string;
  description?: string;
};
export type TypeBtnShowProps = {
  params: TypeParams;
  render: (response: any) => React.ReactNode;
  labels: Labels;
  loader?: React.ReactNode;
  className?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  hideTrigger?: boolean;
};

export const ShowBtn = ({
  params,
  render,
  labels,
  loader,
  className,
  open,
  onOpenChange,
  hideTrigger,
}: TypeBtnShowProps) => {
  const [dataShow, setDataShow] = useState(null);

  const getShow = async () => {
    const { data } = await params.func(params.funcParams || null);
    setDataShow(data?.response);
  };

  useEffect(() => {
    if (open) getShow();
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {!hideTrigger && (
        <DialogTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="size-7 p-0 text-slate-900 hover:bg-stone-950/10 dark:text-[#F4F4F5]"
            onClick={open === undefined ? getShow : undefined}
          >
            <Eye className="size-5" />
          </Button>
        </DialogTrigger>
      )}
      <DialogContent className={cn("sm:max-w-[450px]", className)}>
        <DialogHeader className="flex flex-col">
          {labels?.title ? (
            <DialogTitle>{labels?.title}</DialogTitle>
          ) : (
            <DialogTitle>Default Title</DialogTitle>
          )}
          {labels?.description && (
            <DialogDescription>{labels?.description}</DialogDescription>
          )}
        </DialogHeader>
        {/* <ScrollArea className="max-h-[80vh] w-full rounded-md mt-4"> */}
        {dataShow ? render(dataShow) : loader ? loader : ""}
        {/* </ScrollArea> */}
      </DialogContent>
    </Dialog>
  );
};
